import type { ActivityHistory, State } from '../../typings'

export const updateActivityHistoryReducer = (
  state: State,
  payload: ActivityHistory[],
): State => {
  payload.forEach((record) => {
    record.auditTime = new Date(record.auditTime)
  })

  return {
    ...state,
    history: payload,
  }
}
